<div class = "contractor-card row" [ngClass]="cssClass">
  <div class = "image-column">
    <div class="overlayer-upper">
      <div class="img-wrapper">
        <img class="cmp-image" src="{{staffer.profileImage}}">
        <div *ngIf="staffer.staffer.isStafferVerified" class="staffy-verified orangebg">
          <i class="fa fa-check"></i>
        </div>
        
        <div *ngIf="staffer?.staffer?.badges?.indexOf('covid-19-vaccine') > -1" class="staffy-verified">
          <div class="staffy-verified-covid">
            <img src="assets/images/Covid-Badge.svg">
          </div>
        </div>


      </div>
      <div class="overlayer"
        [ngClass]="{'overlayer-border':staffer.staffer.isStafferVerified }">
      </div>
    </div>
  </div>

  <div class = "contractor-details">
      <div class = "row header">
        <!-- Contractor name and rating -->
        <div class = "center-column">
          <div class = "heading mont-bold large-font text-capitalize">
            {{staffer.staffer.firstName}} {{staffer.staffer.lastName }}

            <span *ngIf="shouldShowPhoneNumber && staffer.staffer.phoneNumber" class="staffer-phone">
             {{staffer.staffer.phoneNumber}}
            </span>
            
            <span *ngIf="shouldShowPhoneNumber && staffer.staffer.email"  (mouseenter)="showPopover('email')" (mouseleave)="hidePopover()" class="staffer-email"><i   (click)="handleEmailCopyToClipBoard()" class="fas fa-envelope email-icon"></i> 
              <app-copy-popover [copiedToClipBoard]="emailCopied" [showPopover]="showEmailPopOver" [text]="staffer.staffer.email"></app-copy-popover></span>

          </div>

          <span class="also-qualified-chip" *ngIf="qualifyingOtherSkillLabel as label" [title]="'Qualified for this shift via ' + label">
            Qualified via {{ label }}
          </span>

          <div class = "row mont-regular small-font align-center" *ngIf="staffer.staffer.numOfRatedUsers > 3 && staffer.staffer.aggregated_rating > 0">
            <star-rating class="ratings open-request-rating" [value]="staffer.staffer.aggregated_rating" [totalstars]="5"
              checkedcolor="#ff4d00" size="18px" readonly="true"></star-rating>
              <span class = "rating-txt">{{staffer.staffer.aggregated_rating}} ({{staffer.staffer.numOfRatedUsers}})</span>
          </div>

        </div>

        <!-- Contractor signal indicators -->
        <div class = "indicators-and-ratings">
          <div class = "hidden-mobile">
           <div>
            <shared-home-staffer-badges *ngIf="staffer?.staffer?.computedBadges?.length"
            [horizontalOnly]="true" class="client-view" [userData]="staffer.staffer">
            </shared-home-staffer-badges>
          </div>
        </div>
      
          <div class = "progess-bar-container" *ngIf = "staffer?.staffer">
            <app-semi-circle-progress-bar class = "client-app" [progress] = "staffer.staffer.reliabilityRating" [userData] = "staffer.staffer" [staffer] = "userData"></app-semi-circle-progress-bar>
          </div>


          <shared-signals-indicators class = "client-view-badge">
          </shared-signals-indicators>
        </div>
      </div>

     

      <!-- Attendance details-->

      <app-shift-attendance-info 
        *ngIf = "jobItem"
        [jobItem]="jobItem"
        [showPhoneNumber]="shouldShowPhoneNumber"
        [staffer]="staffer.staffer">

      </app-shift-attendance-info>

      <!-- Contractor earning and shift details -->
      <div class = "details">
        
        <div (click)="showContractorDetails = !showContractorDetails" class = "medium-font mont-bold vertical-spacing pointer rq-toggle" [class.is-open]="showContractorDetails">Contractor Details
          <i  class="fa" [ngClass]="showContractorDetails ? 'fa-chevron-up' : 'fa-chevron-down'" style="margin-left: 10px;"></i>
        </div>

        <div class = "row flex-wrap" *ngIf="showContractorDetails">
          <div class = "row rq-verify" *ngIf = "staffer.hasContractorWorkedInUnit">
            <i class="fa fa-user-check"></i>
            <p>Already worked in unit</p>
          </div>

          <div class = "row rq-stat" *ngIf="staffer.distanceFromShift && staffer.distanceFromShift">
            <i class="fa fa-map-marker"></i>
            <p><span class="rq-n">{{staffer.isProvinceNY ? staffer.distanceInMiles: staffer.distanceInKm }}
                {{staffer.isProvinceNY ? 'MI': 'KM' }}</span> away</p>

          </div>

          <div class = "row rq-stat">
            <i class="fa fa-user-check"></i>
            <p> <span class="rq-n">{{staffer.staffer.numOfRecommendations || 0}}</span> recommendations
            </p>
          </div>

          <div class = "row rq-stat">
            <i class="fa fa-user-check"></i>
            <p>
                <span class="rq-n">{{staffer.staffer.shifts_completed || 0}}</span> shifts completed
            </p>
          </div>

          <div class = "row rq-stat">
            <i class="fa fa-user-check"></i>
            <p *ngIf = "staffer.staffer.total_earned">
                <span class="rq-n">${{staffer.staffer.total_earned.toFixed(2)}}</span> earned
            </p>

            <p *ngIf = "!staffer.staffer.total_earned">
              <span class="rq-n">$0</span> earned
            </p>
        </div>

          <div class = "row rq-doc" *ngIf = "userData?.companyType != 'Hospitality' && (staffer.status == 'interested' || staffer.status == 'hired')">
            <i class = "fa fa-warning"></i>
            <p (click) = "viewStafferCertificates(staffer.staffer._id, true)"><a class = "orange underline-only">
                View COVID-19 credential
              </a>
            </p>
          </div>

          <div class = "row rq-verify">
            <i class = "fa fa-check text-success" *ngIf = "(staffer?.staffer?.rcmpVerification?.verified || staffer?.staffer?.byPassRCMPVerification)"></i>
            <i class = "fa fa-times text-danger" *ngIf = "(!staffer?.staffer?.rcmpVerification?.verified && staffer?.staffer?.rcmpVerification?.status != 'pending' && !staffer?.staffer?.byPassRCMPVerification)"></i>
            <i class = "fas fa-clock text-pending" *ngIf = "(staffer.staffer?.rcmpVerification?.status === 'pending' && !staffer?.staffer?.byPassRCMPVerification)"></i>
            <p><span>
                RCMP Verified
              </span>
            </p>
          </div>


          <div class = "row rq-doc">
            <i class = "fa fa-notes-medical"></i>
            <p (click)="viewStafferCertificates(staffer.staffer._id, false)">
                <a class = "orange underline-only">View Credentials</a>
            </p>


            <i class = "fa fa-download"></i>
            <p (click)="downloadStafferCertificates(staffer.staffer._id)" [class.disabled]="isDownloading">
                <a class="orange underline-only">
                  <ion-spinner name="dots" *ngIf="isDownloading" class="inline-spinner"></ion-spinner>
                  <span *ngIf="!isDownloading">Download Credentials</span>
                </a>
            </p>
          </div>

          <div class = "row rq-doc" *ngIf="!isHealthcareClient">
            <i class = "fa fa-tshirt"></i>
            <p (click)="viewStafferApparels(staffer.staffer._id)">
                <a class = "orange underline-only">View Apparel</a>
            </p>
          </div>
          
          <div class = "row rq-doc">
            <i class = "fa fa-file-signature"></i>
            <p (click)="viewVscDeclaration()">
                <a class = "orange underline-only">View VSC Declaration</a>
            </p>
          </div>

          <div class = "row rq-doc" *ngIf="hasResume() && shouldShowResumeButton()">
            <i class = "fa fa-file-pdf"></i>
            <p (click)="viewStafferResume()">
                <a class = "orange underline-only">View Resume</a>
            </p>
          </div>
        </div>

      </div>

      <!-- Bulletins seciton -->
      <div class="details">
      <div (click)="showBulletinDetails = !showBulletinDetails" *ngIf="bulletins.length" class = "medium-font mont-bold vertical-spacing pointer rq-toggle" [class.is-open]="showBulletinDetails">Bulletins
        <i  class="fa" [ngClass]="showBulletinDetails ? 'fa-chevron-up' : 'fa-chevron-down'" style="margin-left: 10px;"></i>
      </div>

      <div class = "row flex-wrap" *ngIf="bulletins.length && showBulletinDetails">
        <div *ngFor="let bulletin of bulletins"  class = "row bulletin-container">
          <div class="bulletin-item">
            <i (click)="showBulletin(bulletin)" class="bulletin-icon text-orange fas fa-file-alt"></i>
            <span (click)="showBulletin(bulletin)" class="bulletin-title">{{bulletin.name}}</span>
            <i *ngIf="bulletin.acknowledgment_date" (click)="showBulletin(bulletin)" class="fa fa-circle-check ack-tick"
              aria-hidden="true"></i>
          </div>
          <div class="bulletin-ack-date" *ngIf ="bulletin.acknowledgment_date">
            Acknowledged on {{bulletin.acknowledgment_date}}
          </div>
          <div class="bulletin-ack-date" *ngIf ="!bulletin.acknowledgment_date">
            Not acknowledged yet
          </div>
       
      </div>
    </div>


      <!-- Contractor history with the client -->
      <div class = "details" *ngIf = "!viewingHistory">
        <div (click) = "loadContractorHistory(staffer.staffer._id)" class = "medium-font mont-bold vertical-spacing pointer rq-toggle" [class.is-open]="showHistoryDetails">History with {{ userData?.entityId?.name }}
          <i  class="fa" [ngClass]="showHistoryDetails ? 'fa-chevron-up' : 'fa-chevron-down'" style="margin-left: 10px;"></i>
        </div>

        <div class = "row flex-wrap" *ngIf = "showHistoryDetails">
          <div class = "row">
            <i class="fas fa-check-double"></i>
            <p *ngIf = "!shiftHistoryStats?.shifts_worked">0 Shifts</p>
            <p *ngIf = "shiftHistoryStats?.shifts_worked" (click) = "viewShiftDetails(true)">
              {{ shiftHistoryStats.shifts_worked || 0}} {{ shiftHistoryStats.shifts_worked < 2 ? "Shift" : "Shifts"}} <span class = "smaller-font orange underline">See Details</span></p>
          </div>

          <div class = "row">
            <i class="fas fa-calendar-check"></i>
            <p *ngIf = "!shiftHistoryStats?.trainingComplete">Training complete: N/A</p>
            <p *ngIf = "shiftHistoryStats?.trainingComplete">Training complete: <span class = "orange underline-only">{{ shiftHistoryStats.trainingComplete |  momentPipeUnix:'DD/MM/YYYY'}}</span></p>
          </div>

          <div class = "row">
            <i class="fa fa-building-o"></i>
            <p *ngIf = "!shiftHistoryStats?.unitsWorked || shiftHistoryStats?.unitsWorked?.length === 0">N/A Unit</p> 
            <p *ngIf = "shiftHistoryStats?.unitsWorked?.length >= 1">
              {{ shiftHistoryStats.unitsWorked.length }} {{ shiftHistoryStats.unitsWorked.length === 1 ? "Unit" : "Units"}} : <span class = "smaller-font orange underline" (click) = "viewUnitNumbers()">See Details</span></p>
          </div>

          <div class = "row" >
            <i class="fas fa-calendar-alt"></i>
            <p *ngIf = "!shiftHistoryStats?.futureShifts">0 Future Shifts</p>
            <p *ngIf = "shiftHistoryStats?.futureShifts" (click) = "viewShiftDetails(false)">
              {{ shiftHistoryStats.futureShifts || 0}} Future {{ shiftHistoryStats.futureShifts < 2 ? "Shift" : "Shifts"}}: <span class = "smaller-font orange underline">See Details</span></p>
          </div>
        </div>
  </div>

</div>

